import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { NoData } from 'src/@vymo/ui/blocks';
import { Form } from 'src/@vymo/ui/molecules';
import { FormVersion } from 'src/@vymo/ui/molecules/form/types';
import {
  getBeforeSaveHookConfig,
  getGroupedHistories,
  getModificationTag,
  mapInputsToFormValues,
} from './queries';
import { GroupedHistoryProps } from './types';
import styles from './index.module.scss';

function GroupedHistory({
  histories,
  revyre,
  profileDetails,
}: GroupedHistoryProps) {
  const historyItems = histories || [];
  const groupedHistories = getGroupedHistories(historyItems);

  return (
    <div className={styles.groupedHistory}>
      {groupedHistories.map((group) => (
        <>
          <Text type="h6" classNames={styles.groupedHistory__dateHeader}>
            {group.date}
          </Text>
          {group.histories.map((history) => {
            const inputsToShow = history?.inputs || [];
            return (
              <div className={styles.groupedHistory__history}>
                <Text type="label">{history?.time || ''}</Text>

                <div className={styles.groupedHistory__history__data}>
                  <div
                    className={styles.groupedHistory__history__headerWrapper}
                  >
                    <div
                      className={styles.groupedHistory__history__titleWrapper}
                    >
                      <div className={styles.groupedHistory__history__title}>
                        {history?.title || ''}
                      </div>
                      <div className={styles.groupedHistory__history__subTitle}>
                        {history?.subTitle || ''}
                      </div>
                    </div>
                    <div className={styles.groupedHistory__history__tag}>
                      {getModificationTag(history.type || 'vymo')}
                    </div>
                  </div>

                  {Boolean(inputsToShow?.length) && (
                    <Form
                      ref={null}
                      id="auditCardForm"
                      name="auditCardForm"
                      span="1fr 1fr"
                      // eslint-disable-next-line @typescript-eslint/no-unused-vars
                      onChange={(formFields) => {}}
                      className={styles.groupedHistory__history__data__form}
                      config={{
                        version: FormVersion.webRevyre,
                        data: inputsToShow || [],
                        grouping: history?.grouping,
                        fieldItemConfig: {
                          showDisabledIcon: true,
                        },
                        ...getBeforeSaveHookConfig({ revyre }),
                        viewMode: true,
                        metaData: {
                          profileDetails,
                        },
                      }}
                      value={mapInputsToFormValues(
                        (inputsToShow || []).reduce((acc, inp) => {
                          if (inp.value) {
                            acc[inp.code] = inp.value;
                          }
                          return acc;
                        }, {}),
                      )}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </>
      ))}
      {Boolean(!groupedHistories?.length) && (
        <NoData
          classNames={styles.groupedHistory__noData}
          message="No Histories Found"
        />
      )}
    </div>
  );
}

export default GroupedHistory;
